export const SUBSCRIPTION_PLAN = [
  "Basic",
  "Premium",
  "Free",
  "Gold",
  "Unlimited",
  "Starter",
  "Business",
  "Professional",
  "Advanced",
  "Silver",
  "Bronze",
  "Standard",
  "Pro",
  "Enterprise",
  "Platinum",
];
